@layer refine.base {
  :host {
    --_menu-color: var(--menu-item-color, var(--_theme-base, var(--color-primary)));
    --_hover-bg: var(--menu-item-hover-bg, var(--color-contrast-100));
    --_focus-color: var(--menu-item-focus-color, var(--_menu-color));
    --_focus-bg: var(--menu-item-focus-bg, color-mix(in oklch, var(--_menu-color) 12%, var(--color-contrast-100)));
    --_selection-bg: var(
      --menu-item-selection-bg,
      color-mix(in oklch, var(--color-contrast-900) 5%, var(--color-canvas))
    );
    --_checked-color: var(--menu-item-checked-color, var(--_menu-color));
    --_checked-bg: var(--menu-item-checked-bg, color-mix(in oklch, var(--_menu-color) 18%, var(--color-canvas)));

    display: block;
    outline: none;
  }

  .item {
    display: flex;
    gap: var(--_gap, var(--size-2));
    align-items: center;
    padding: var(--_item-padding, var(--size-1-5) var(--size-3));
    font-size: var(--_font-size, var(--text-sm));
    line-height: var(--leading-normal);
    white-space: nowrap;
    cursor: pointer;
    user-select: none;
    border-radius: 0;
    transition:
      background var(--transition-fast),
      color var(--transition-fast);
  }

  :host(:first-of-type) .item {
    border-radius: var(--rounded-sm) var(--rounded-sm) 0 0;
  }

  :host(:last-child) .item {
    border-radius: 0 0 var(--rounded-sm) var(--rounded-sm);
  }

  :host(:first-of-type:last-child) .item {
    border-radius: var(--rounded-sm);
  }

  :host(:not([disabled])) .item:hover {
    background: var(--_hover-bg);
  }

  :host(:focus-visible) .item {
    color: var(--_focus-color);
    background: var(--_focus-bg);
  }

  .item.is-checked {
    font-weight: var(--font-medium);
    color: var(--_checked-color);
  }

  :host([disabled]) .item {
    color: var(--color-contrast-400);
    pointer-events: none;
    cursor: not-allowed;
    opacity: 0.6;
  }

  .icon-slot {
    display: contents;
  }

  .item-check {
    display: inline-flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    width: 1.25rem;
    color: currentcolor;
  }

  /* CSS-based check/radio indicator — no Unicode characters */
  .item-check::before {
    display: block;
    width: 0.875rem;
    height: 0.875rem;
    content: '';
    border: 1.5px solid currentcolor;
    transition:
      background var(--transition-fast),
      border-color var(--transition-fast);
  }

  .item.is-checkbox .item-check::before {
    border-radius: 2px;
  }

  .item.is-radio .item-check::before {
    border-radius: 50%;
  }

  .item.is-checked .item-check::before {
    background: currentcolor;
  }

  /* Radio checked: filled dot via inset box-shadow */
  .item.is-radio.is-checked .item-check::before {
    background: transparent;
    box-shadow: inset 0 0 0 3px currentcolor;
  }

  .item-label {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

@media (pointer: coarse) {
  .item {
    padding: var(--size-2-5) var(--size-3);
  }
}
